// sort columns
export const SORT_ORDER_ID = 'order_id'
export const SORT_CUSTOMER_NAME = 'customer_name'
export const SORT_ORDER_APPOINTMENT_DATETIME = 'order_appointment_datetime'
export const SORT_CART_TOTAL = 'cart_total'
export const SORT_ORDER_TOTAL = 'order_total'
export const SORT_ORDER_STATUS = 'order_status'
export const SORT_SHOP_NAME = 'shop_name'
export const SORT_ORDER_CREATED_AT = 'order_created_at'
export const SORT_ORDER_UPDATED_AT = 'order_updated_at'
export const SORT_OVER_RETAIL = 'order_over_retail'
export const SORT_AI_INVOICE = 'order_ai_invoice_inconsistency'
export const SORT_CUSTOMER_BRAINTREE = 'order_customer_braintree_inconsistency'
export const SORT_TAX = 'order_tax_inconsistency'
export const SORT_MISSING_MAPPING='order_missing_mappings'
export const SORT_ORDER_PAID = 'order_previous_payments'

// sort direction
export const DIRECTION_ASC = 'ASC'
export const DIRECTION_DESC = 'DESC'

// order status/scope filters
export const ALL = 'all'
export const STATUS_CANCELED = 'status_canceled'
export const STATUS_INITIATED_BY_USER = 'status_initiated_by_user'
export const STATUS_AWAITING_APPROVAL = 'status_awaiting_approval'
export const STATUS_APPROVAL = 'status_approval'
export const STATUS_PAID = 'status_paid'
export const STATUS_WALK_IN = 'status_walk_in'
export const STATUS_ACTIVE = 'status_active'
export const STATUS_CHECKED_IN = "status_checked_in"
export const STATUS_IN_MANUAL_REVIEW = 'status_in_manual_review'
export const STALLED = 'stalled'
export const STATUS_PRICE_REVIEW = "status_price_review"
export const STATUS_ACTIVE_NEEDS_RESCHEDULE = "status_active_needs_reschedule"
export const STATUS_WALK_IN_NEEDS_RESCHEDULE = "status_walk_in_needs_reschedule"
export const STATUS_INDEFINITE_OPEN = "status_indefinite_open"
export const STATUS_USER_INITIATED_NEEDS_RESCHEDULE = "status_user_initiated_needs_reschedule"
export const STATUS_WALK_IN_ACTIVE_NEEDS_RESCHEDULE = "status_walk_in_active_needs_reschedule"
export const STATUS_WALK_IN_ACTIVE = "status_walk_in_active"
export const HIGH_TOTAL = 'high_total'
export const RECONCILED = 'reconciled'
export const RESOLVED_RECONCILIATION_FAILURE = 'resolved_reconciliation_failure'
export const RECONCILIATION_FAILURE = 'reconciliation_failure'
export const REFUNDED = 'refunded'
export const OVER_RETAIL = 'over_retail'
export const RECONCILIATION_SCOPES = [RECONCILED, RESOLVED_RECONCILIATION_FAILURE, RECONCILIATION_FAILURE, REFUNDED, OVER_RETAIL]
export const FORBIDDEN_MULTI_SCOPES = [ALL, STALLED, HIGH_TOTAL] + RECONCILIATION_SCOPES

// custom filters
export const CUSTOMER_PHONE = 'customer_phone'
export const CUSTOMER_NAME = 'customer_name'
export const CUSTOMER_EMAIL = 'customer_email'
export const VEHICLE_VIN = 'vehicle_vin'
export const AFFILIATION_IDS = 'affiliation_ids'

// date filters
export const YESTERDAY = 'yesterday'
export const TODAY = 'today'
export const TOMORROW = 'tomorrow'
export const THIS_WEEK = 'this_week'
export const ALL_TIME = 'all_time'
export const SINGLE_DATE = 'single_date'
export const DATE_RANGE = 'date_range'
export const DATE_ATTR_APPT_TIME = 'appointment_datetime'
export const DATE_ATTR_CREATED_AT = 'created_at'
